import { useEffect, useState } from "react";
import "./index.css";
import "./redirections.css";

//@ts-ignore
import AOS from 'aos';
import 'aos/dist/aos.css';

import iconlogo from "./photoraccalogo.png";
// import reactLogo from "./react.svg"; // Unused import removed
import { ContactPage, DownloadPage, HomePage, PurchasePage } from "./redirections";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";

// Define a type for your views to prevent typos
type ViewState = "Home" | "Download" | "Purchase";

const PageWrapper = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);


export function App() {
  const navigate = useNavigate();
  const [view, setView] = useState<ViewState>("Home");
  useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => {
      const target = e.target as HTMLElement;
      const isTouchingStickerArea = target.closest(".PhotoPrev");

      if (isTouchingStickerArea) return;

      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    const handleWheel = (e: WheelEvent) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };

    const options: AddEventListenerOptions = { passive: false };

    document.addEventListener("touchmove", handleTouchMove, options);
    document.addEventListener("wheel", handleWheel, options);

    return () => {
      document.removeEventListener("touchmove", handleTouchMove, options);
      document.removeEventListener("wheel", handleWheel, options);
    };
  }, []);

  return (
    <div className="AppContainer">
      <nav className="HeaderMain">
        <button
          onClick={() => navigate("/")}
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <img src={iconlogo} alt="Photoracca Logo" style={{ width: "300px", height: "auto" }} />
        </button>
        <button className="DownloadButton" onClick={() => navigate("/downloads")}>
          Download
        </button>
      </nav>

      <main>
        <BrowserRedirection />
      </main>

      <footer>
        <div style={{ fontFamily: "'Open Sans', sans-serif", display: "flex", justifyContent: "center", padding: "20px" }}>
          ©2026 Ronnel Mitra, All Rights Reserved | Built with motion.dev
        </div>
      </footer>
    </div>
  );
}

function BrowserRedirection() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><HomePage /></PageWrapper>} />
        <Route path="/downloads" element={<PageWrapper><DownloadPage /></PageWrapper>} />
        <Route path="/purchase" element={<PageWrapper><PurchasePage /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><ContactPage /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  )
}

export default App;